import { Text, View, StyleSheet, Image, Dimensions, TouchableOpacity, Animated, ActivityIndicator } from 'react-native'
import theme from '../../../theme'
import { colorText } from '../../../themeConstants'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 0,
    },
    Card: {
        // borderTopStartRadius: 25,
        // borderTopEndRadius: 25,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
    },
    textHeader: {
        width: Dimensions.get('window').width * 1,
        marginTop: 20,
        marginBottom: 10,
        paddingHorizontal: 10,
        alignContent: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: 22,
        color: theme.colors.textPrimary,
    },
    pointsBlock: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginBottom: 10,
    },
    containerData: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {
        fontSize: 16,
        color: 'white',
        marginHorizontal: 5,
        marginVertical: 5,
    },
    subtitle: {
        fontSize: 13,
        color: 'white',
        marginHorizontal: 5,
        marginVertical: 5,
    },
    value: {
        fontSize: 32,
        fontWeight: 'bold',
        color: 'white',
    },
    gradient: {
        ...StyleSheet.absoluteFillObject,
    },
})

export default styles
